// src/api/contactApi.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const contactApi = {
  // Envoyer le formulaire de contact
  sendContact: async (contactData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/contact`, contactData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        // Erreur de réponse du serveur
        throw new Error(error.response.data.message || 'Erreur lors de l\'envoi du formulaire');
      } else if (error.request) {
        // Pas de réponse du serveur
        throw new Error('Impossible de contacter le serveur');
      } else {
        // Erreur de configuration
        throw new Error('Erreur lors de la requête');
      }
    }
  }
};

export default contactApi;